<template>
    <div ref="modalCreateTicket" class="modal mx-0 fade" tabindex="-1" role="dialog" id="modalCreateTicket" data-backdrop="static">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header py-1">
                    <h5 class="modal-title py-2">{{ this.type == this.$constant.ticket_receipt_cash_book ? $t('message.modalCreateTicketForCash.title_create_receipt') : $t('message.modalCreateTicketForCash.title_create_payment') }}</h5>
                    <button type="button" class="close" aria-label="Close" @click="skip()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body my-4 py-0 mx-3" >
                    <div class="row">
                        <div class="col-lg-6 col-sm-12">
                            <div class="row">
                                <h6 class="text-bold">{{ $t('message.modalCreateTicketForCash.info_common') }}</h6>
                            </div>
                            <div class="row py-1">
                                <div class="col-4 pl-4 text-bold">{{ $t('message.modalCreateTicketForCash.objects') }}:<span class="text-danger">*</span></div>
                                <div class="col-8">
                                    <q-select v-model="entry.objectId" :default-options="objects" :multiple="false" 
                                    :placeholder="$t('message.modalCreateTicketForCash.placeholder.objects')"/>
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-4 pl-4 text-bold">{{ $t('message.modalCreateTicketForCash.amount') }}:<span class="text-danger">*</span></div>
                                <div class="col-8">
                                    <InputNumber v-model="entry.amount" class="mb-0" 
                                    :placeholder="this.type == this.$constant.ticket_receipt_cash_book ? $t('message.modalCreateTicketForCash.placeholder.amount_receipt') : $t('message.modalCreateTicketForCash.placeholder.amount_payment')" 
                                    :formatNumber="true"/>
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-4 pl-4 text-bold">{{ this.type == this.$constant.ticket_receipt_cash_book ? $t('message.modalCreateTicketForCash.reason_receipt') : $t('message.modalCreateTicketForCash.reason_payment') }}:</div>
                                <div class="col-8">
                                    <input type="text" v-model.trim="entry.reason" 
                                    :placeholder="$t('message.modalCreateTicketForCash.placeholder.reason')"
                                    class="form-control">
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-4 pl-4 text-bold">{{ this.type == this.$constant.ticket_receipt_cash_book ? $t('message.modalCreateTicketForCash.user_receipt') : $t('message.modalCreateTicketForCash.user_payment') }}:<span class="text-danger">*</span></div>
                                <div class="col-8">
                                    <q-select v-model="entry.userId" :default-options="users" :multiple="false" 
                                    :placeholder="$t('message.modalCreateTicketForCash.placeholder.user')"/>
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-4 pl-4 text-bold">{{ $t('message.modalCreateTicketForCash.note') }}:</div>
                                <div class="col-8">
                                    <textarea class="form-control" 
                                        v-model.trim="entry.note" 
                                        :placeholder="$t('message.modalCreateTicketForCash.placeholder.note')">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <div class="row">
                                <h6 class="text-bold">{{ $t('message.modalCreateTicketForCash.document') }}</h6>
                            </div>
                            <div class="row py-1">
                                <div class="col-4 pl-4 text-bold">{{ $t('message.modalCreateTicketForCash.planning_day') }}:</div>
                                <div class="col-8">
                                    <input type="text" v-model="entry.planningDay" class="form-control cursor-ban" readonly="true">
                                </div>
                            </div>
                            <div class="row py-1">
                                <div class="col-4 pl-4 text-bold">{{ $t('message.modalCreateTicketForCash.document_number') }}:</div>
                                <div class="col-8">
                                    <input type="text" class="form-control"
                                        v-model.trim="entry.documentNumber"
                                        :placeholder="$t('message.modalCreateTicketForCash.placeholder.document_number')">
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="row pt-4">
                        <div class="col-lg-12 flex-end">
                            <AppPermission :permission="this.$permissions.cashbooks.create?? '' ">
                                <button type="button" class="btn btn-save mx-1" @click="save">
                                    <i class="fa fa-save"></i>
                                    {{ $t('message.modalCreateTicketForCash.button.save') }}
                                </button>                              
                                 <!-- <AppPermission :permission="this.$permissions.cashbooks.print?? '' ">
                                    <button type="button" class="btn btn-save mx-1" @click="save(true)">
                                        <i class="fa fa-save"></i>
                                        {{ $t('message.modalCreateTicketForCash.button.saveAndPrint') }}
                                    </button>
                                </AppPermission>    -->
                            </AppPermission>
                            <button type="button" class="btn btn-secondary mx-1" @click="skip">
                                <i class="fa fa-ban"></i>
                                {{ $t('message.modalCreateTicketForCash.button.skip') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalConfirm ref="ModalConfirm" @confirm="hide()" :content="this.contentConfirm" :title="this.titleConfirm"/>
</template>
<script>
import {$post, isChangeData, $alert} from "@/lib/utils";
import toastr from 'toastr';
import InputNumber from "@/components/forms/InputNumberCustom";
import moment from 'moment';
import store from "@/store";
import QSelect from "@/components/QSelect";
import ModalConfirm from "@/components/ModalConfirm.vue";
import AppPermission from '@/components/AppPermission';
export default {
    name: "ModalCreateTicket",
    components: {
        InputNumber, QSelect, ModalConfirm,AppPermission
    },
    data(){
        return {
            entry: {},
            default: {},
            type: null,
            typeSrc: null,
            users: store.state.GlobalConfig.users,
            currentUser: store.state.Auth ? store.state.Auth.user : {},
            objects: [],
            contentConfirm: null,
            titleConfirm: null,
        }
    },
    methods: {
        show(type, objects) {
            this.clearData();
            if(type){
                this.type = type;
                this.typeSrc = type == this.$constant.ticket_receipt_cash_book ? this.$constant.type_ticket_receipt_cash_book : this.$constant.type_ticket_payment_cash_book;
                this.objects = objects;
                this.entry.planningDay = moment().format('DD/MM/YYYY HH:mm');
                this.entry.userId = this.currentUser.id ?? null;
                this.entry.objectId = this.$constant.object_other_cash_book;
                this.default = {...this.entry};
                window.jQuery(this.$refs.modalCreateTicket).modal('show');
            }
        },
        clearData(){
            this.entry = {
                'objectId' : null,
                'amount' : null,
                'reason' : null,
                'userId' : null,
                'note' : null,
                'planningDay' : null,
                'documentNumber' : null,
            };
            this.default = {
                'objectId' : null,
                'amount' : null,
                'reason' : null,
                'userId' : null,
                'note' : null,
                'planningDay' : null,
                'documentNumber' : null,
            };
            this.titleConfirm = null;
            this.contentConfirm = null;
        },
        hide(){
            this.clearData();
            window.jQuery(this.$refs.modalCreateTicket).modal('hide');
        },
        skip(){
            const isChange = isChangeData(this.entry, this.default);
            if(isChange == true){
                this.hide();
            }else{
                this.titleConfirm = this.$t('message.modalCreateTicketForCash.title_confirm_close');
                this.contentConfirm = this.type == this.$constant.ticket_receipt_cash_book ? this.$t('message.modalCreateTicketForCash.content_confirm_close_receipt') : this.$t('message.modalCreateTicketForCash.content_confirm_close_payment');
                this.$refs.ModalConfirm.show();
            }
        },
        async save(print = false){
            if(!this.entry.typeSrc){
                this.entry.typeSrc = this.typeSrc;
            }
            if(!this.entry.type){
                this.entry.type = this.type;
            }
            if(!this.entry.branchId){
                this.entry.branchId = store.state.CurrentBranch.id;
            }
            const res = await $post('/v1/cash-book/create', {...this.entry});
            if(res.code === 422){
                let errors = res.messages.errors;
                Object.keys(errors).forEach(function(key) {
                    $alert({code: res.code, message: errors[key][0]});
                });
            }
            else if(res.status.code == 200){
                if(!res.result.status){
                    const message = this.type == this.$constant.ticket_receipt_cash_book ? this.$t('message.modalCreateTicketForCash.alert.create_receipt_error') : this.$t('message.modalCreateTicketForCash.alert.create_payment_error');
                    $alert({code: 500, message: message});
                }else{
                    const message = this.type == this.$constant.ticket_receipt_cash_book ? this.$t('message.modalCreateTicketForCash.alert.create_receipt_success') : this.$t('message.modalCreateTicketForCash.alert.create_payment_success');
                    $alert({code: 200, message: message});
                    this.hide();
                    if(print){
                        this.$emit('print', res.result.data);
                    }
                    this.$emit('loadData');
                }
            }
        }
    },
    beforeUnmount() {
        this.hide();
    },
}
</script>
<style scoped>
</style>